import PropTypes from 'prop-types'
import { useEffect } from 'react'

import useIframe from '../../../shared/hooks/useIframe'
import Iframe from '../../../shared/Iframe'
import { useAuthentication } from 'authentication'
import { useTranslation } from 'react-i18n-lite'
import ActivityEmbeddedSitemodel from '../ActivityInput/ActivityEmbeddedSitemodel/ActivityEmbeddedSitemodel'

const SiteRenderer = ({ sitemodelUuid, urlSiteRenderer }) => {
  return (
    <ActivityEmbeddedSitemodel
      sitemodelUuid={sitemodelUuid}
      urlSiteRenderer={urlSiteRenderer}
    />
  )
}

SiteRenderer.propTypes = {
  sitemodelUuid: PropTypes.string.isRequired,
  urlSiteRenderer: PropTypes.string.isRequired
}

export default SiteRenderer
